import { Link } from "wouter";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-stone-50 flex flex-col">
      <Header />
      <div className="flex-1 container pt-24 pb-16 flex flex-col items-center justify-center text-center">
        <div className="w-24 h-24 rounded-full bg-stone-200 flex items-center justify-center mb-6">
          <span className="text-5xl font-bold text-stone-400">404</span>
        </div>
        <h2 className="text-2xl font-bold text-stone-900">
          ページが見つかりませんでした
        </h2>
        <p className="mt-2 text-stone-600 max-w-md">
          お探しのページは存在しないか、移動した可能性があります。
        </p>
        <Link href="/" className="btn-primary mt-8">
          トップページへ戻る
        </Link>
      </div>
      <Footer />
    </div>
  );
}
